import { FormControl, ValidatorFn } from "@angular/forms";

export const convertToAbsolute = (control: FormControl) => {
    if(!control.value && control.value!==-0)
        return null;

    if(control.value<0){
        control.patchValue(Math.floor(Math.abs(control.value)), {onlySelf:true, emitEvent:false });
    }


  return null;
};

